/**
/**
 * Merges the widget configuration from its two sources, key by key at every nesting level.
 *
 * `source` (the HTML data attributes) takes precedence over `target` (the GET widget API
 * configuration blob). Precedence uses `??` rather than `||`, so an explicit `false` in a
 * data attribute overrides a `true` from the API rather than falling through to it.
 *
 * @param target the configuration from the GET widget API
 * @param source the configuration parsed from the HTML data attributes
 * @returns the merged configuration
 */
export function deepMerge<T extends Record<string, any>>(target: T, source: T): T {
    if (Array.isArray(target) && Array.isArray(source)) {
        // @ts-ignore
        return [...source, ...target] as T; // Ensure source takes precedence while keeping both arrays
    } else if (typeof target === 'object' && typeof source === 'object') {
        return Object.keys({ ...target, ...source }).reduce((acc, key) => {
            // @ts-ignore
            acc[key] =
                key in target && key in source
                    ? deepMerge(target[key], source[key]) // Recursively merge
                    : source[key] ?? target[key];
            return acc;
        }, {} as T);
    }
    return source; // If not an object/array, source always wins
}
